import { Component, computed, input, signal } from '@angular/core';
import { TimeFormatPipe } from '../../pipes/time-format.pipe';
import { AnimateOpenDirective } from '../../directives/animate-open.directive';

export type ContactHours = {
  day: string;
  open: string;
  close: string;
};

@Component({
  selector: 'app-contact-hours',
  imports: [TimeFormatPipe, AnimateOpenDirective],
  templateUrl: './contact-hours.component.html',
  styleUrl: './contact-hours.component.scss',
})
export class ContactHoursComponent {
  contactHours = input.required<ContactHours[] | undefined>();

  open = signal(false);

  private viewModel = computed(() => {
    return {
      open: this.open(),
      contactHours: (this.contactHours() || []).map((value) => {
        return {
          ...value,
          isClosed: value.open === '00:00:00' && value.close === '00:00:00',
        };
      }),
    };
  });

  get vm() {
    return this.viewModel();
  }
}
